let productGalleryInitialized = false;

function initProductGalleries() {
  const galleryInstances = {};

  document.querySelectorAll(".js-product-gallery").forEach((galleryEl) => {
    const group = galleryEl.dataset.group;

    // Get thumbs container and parent wrapper
    const thumbsEl = document.querySelector(
      `.product-thumbs[data-group="${group}"]`,
    );
    const thumbsContainer = document.querySelector(
      `.c-product-thumbnails-container[data-group="${group}"]`,
    );

    // ---- 1. Init THUMB SWIPER (responsive: horizontal below 1000px, vertical above) ----
    const thumbsSwiper = new Swiper(thumbsEl, {
      // Default for mobile/tablet (< 1000px)
      direction: "horizontal",
      slidesPerView: "auto",
      spaceBetween: 10,
      freeMode: false,
      watchSlidesProgress: true,
      centeredSlides: false,
      // Breakpoint for desktop (>= 1000px)
      breakpoints: {
        1000: {
          direction: "vertical",
        },
      },
      navigation: {
        nextEl: thumbsContainer?.querySelector(".howies-swiper-button-next"),
        prevEl: thumbsContainer?.querySelector(".howies-swiper-button-prev"),
      },
      on: {
        click(event) {
          thumbsSwiper.slideTo(this.clickedIndex);
        },
        slideChange: function () {
          // Sync main gallery when thumb navigation is used
          if (
            mainSwiper &&
            thumbsSwiper.activeIndex !== mainSwiper.activeIndex
          ) {
            mainSwiper.slideTo(thumbsSwiper.activeIndex);
          }
        },
      },
    });

    // ---- 2. Init MAIN SWIPER (your fade slider) ----
    const mainSwiper = new Swiper(galleryEl, {
      spaceBetween: 0,
      loop: false,
      slidesPerView: 1,
      centeredSlides: true,
      effect: "fade",
      fadeEffect: { crossFade: true },
      autoHeight: true,
      thumbs: {
        swiper: thumbsSwiper,
      },
    });

    // Track the pair
    galleryInstances[group] = {
      main: mainSwiper,
      thumbs: thumbsSwiper,
    };

    // Hide all by default (CSS already hides them)
    const galleryGroup = document.querySelector(
      `.c-product-gallery-group[data-group="${group}"]`,
    );
    if (galleryGroup) galleryGroup.classList.remove("is-active");
  });

  // Helper to switch visible gallery based on variant image
  function showGalleryForImage(selectedImageId) {
    if (!selectedImageId) return;

    let targetGroup = null;

    Object.keys(galleryInstances).forEach((group) => {
      const galleryEl = galleryInstances[group].main.el;
      if (galleryEl.querySelector(`[data-media-id="${selectedImageId}"]`)) {
        targetGroup = group;
      }
    });

    if (!targetGroup) return;

    Object.keys(galleryInstances).forEach((group) => {
      const { main, thumbs } = galleryInstances[group];
      const galleryGroup = document.querySelector(
        `.c-product-gallery-group[data-group="${group}"]`,
      );

      if (group === targetGroup) {
        if (galleryGroup) galleryGroup.classList.add("is-active");

        // Update both Swiper instances after showing
        setTimeout(() => {
          thumbs.update();
          main.update();
          main.slideTo(0);
        }, 50);
      } else {
        if (galleryGroup) galleryGroup.classList.remove("is-active");
      }
    });
  }

  // Variant change event
  document.addEventListener("variant:imageChange", function (event) {
    showGalleryForImage(event.detail.imageId);
    showProductCardImage(event.detail.imageId, event.detail.variantId);

    // Only update price if priceFormatted is provided (not on hover preview)
    if (event.detail.priceFormatted !== null) {
      updatePrice(
        event.detail.priceFormatted,
        event.detail.productId,
        event.detail.compareAtPriceFormatted,
      );
    }
  });

  // Initial variant
  const initialVariantSelect = document.querySelector("#variant-select");
  if (initialVariantSelect) {
    const selectedOption =
      initialVariantSelect.options[initialVariantSelect.selectedIndex];
    const initialImageId = selectedOption?.dataset.imageId;
    showGalleryForImage(initialImageId);
  }

  // If only one gallery, show it
  if (Object.keys(galleryInstances).length === 1) {
    const group = Object.keys(galleryInstances)[0];
    const { main, thumbs } = galleryInstances[group];
    const galleryGroup = document.querySelector(
      `.c-product-gallery-group[data-group="${group}"]`,
    );
    if (galleryGroup) galleryGroup.classList.add("is-active");

    setTimeout(() => {
      thumbs.update();
      main.update();
    }, 50);
  }

  // Handle window resize to update Swiper breakpoints
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      Object.keys(galleryInstances).forEach((group) => {
        const { main, thumbs } = galleryInstances[group];
        thumbs.update();
        main.update();
      });
    }, 150);
  });

  // Simple video play/pause on click
  document.addEventListener("click", function (e) {
    const video = e.target.closest("video.product-main-video");
    if (!video) return;

    const wrapper = video.closest(".product-main-video-wrapper");

    if (video.paused) {
      video.play();
      video.classList.remove("is-paused");
      video.classList.add("is-playing");
      if (wrapper) {
        wrapper.classList.remove("is-paused");
        wrapper.classList.add("is-playing");
      }
    } else {
      video.pause();
      video.classList.remove("is-playing");
      video.classList.add("is-paused");
      if (wrapper) {
        wrapper.classList.remove("is-playing");
        wrapper.classList.add("is-paused");
      }
    }
  });
}

function showProductCardImage(imageId, variantId) {
  // Find the variant image group to show
  const elementToShow = document.querySelector(
    `[data-product-card-variant-img="${imageId}"]`,
  );

  if (!elementToShow) return; // Exit if not found

  // Show the target element
  elementToShow.style.display = "block";

  // Hide its siblings (other variant image groups)
  const siblings = Array.from(elementToShow.parentNode.children).filter(
    (el) =>
      el !== elementToShow && el.hasAttribute("data-product-card-variant-img"),
  );
  siblings.forEach((sibling) => {
    sibling.style.display = "none";
  });

  // Find the wrapping link around the image
  const atcLink = elementToShow.closest(".c-product-card-atc__link");
  if (atcLink) {
    const url = new URL(atcLink.href, window.location.origin);
    url.searchParams.set("variant", variantId); // add or replace ?variant=variantId
    atcLink.href = url.toString();
  }
}

function updatePrice(
  priceFormatted,
  productId,
  compareAtPriceFormatted = null,
) {
  const infoPriceEls = document.querySelectorAll(
    `.js-product-info__price[data-product-price-id="${productId}"]`,
  );

  infoPriceEls.forEach((el) => {
    if (compareAtPriceFormatted && compareAtPriceFormatted !== priceFormatted) {
      el.innerHTML = `
        <span class="c-product-info__price--compare">${compareAtPriceFormatted}</span>
        <span class="c-product-info__price--sale">${priceFormatted}</span>
      `;
    } else {
      el.innerHTML = `
        <span class="c-product-info__price--regular">${priceFormatted}</span>
      `;
    }
  });
}

// Initialize on DOM ready
document.addEventListener("DOMContentLoaded", () => {
  initProductGalleries();
});

// Re-initialize after AJAX collection update
if (!productGalleryInitialized) {
  productGalleryInitialized = true;

  document.addEventListener("collection:updated", () => {
    initProductGalleries();
  });
}

export { initProductGalleries };
